<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card>
      <div v-if="errormessage">
        <v-alert
          dismissible
          v-model="errormessage"
          dense
          outlined
          type="error"
          >{{ errormessage }}</v-alert
        >
      </div>

      <v-toolbar>
        <v-toolbar-title>{{ name }}</v-toolbar-title>
        <v-spacer></v-spacer>
        Add new
        <v-btn
          @click="newUser()"
          class="ma-2"
          outlined
          small
          fab
          color="indigo"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <template v-slot:extension>
          <v-tabs v-model="tab" align-with-title>
            <v-tabs-slider></v-tabs-slider>
            <v-tab v-for="item in tabitems" :key="item.index">
              {{ item.name }}
            </v-tab>
          </v-tabs>
        </template>
      </v-toolbar>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in tabitems" :key="item.index">
          <v-card flat>
            <v-data-table
              v-if="item.index === 0"
              :headers="headers"
              :items="users"
              item-value="Id_No"
              :search="search"
              :custom-filter="filterOnlyCapsText"
            >
              <template v-slot:top>
                <v-text-field
                  v-model="search"
                  label="Search"
                  class="mx-4"
                ></v-text-field>
              </template>
              <template v-slot:item="{ item }">
                <tr :class="checkDel(item)">
                  <td>
                    <v-avatar color="" v-if="item.imagestring">
                      <img
                        alt="No Image"
                        :src="'data:image/jpeg;base64,' + item.imagestring"
                      />
                    </v-avatar>

                    <span color="" v-if="!item.imagestring"> No Image </span>
                  </td>
                  <td>{{ item.id }}</td>
                  <td>{{ item.UserName.toUpperCase() }}</td>
                  <td>{{ item.UserFullName.toUpperCase() }}</td>
                  <td>{{ item.Mobile }}</td>
                  <td v-html="formaticon(item.isAdmin)"></td>
                  <td v-html="formaticon(item.isRep)"></td>
                  <td v-html="formaticon(item.enabled)"></td>
                  <td>
                    <v-btn
                      color="primary"
                      @click.stop="getUserDetails(item.UserName)"
                    >
                      Manage
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-tab-item>
      </v-tabs-items>

      <v-dialog v-model="dialog" max-width="900px">
        <v-card>
          <v-card-title>{{ dialogtitle }}</v-card-title>
          <v-card-text>
            <v-alert
              dismissible
              v-if="dialogerror"
              dense
              outlined
              type="error"
              >{{ dialogerror }}</v-alert
            >
            <v-layout justify-center>
              <v-avatar v-if="selectedUser.imagestring" color="" size="96">
                <img
                  alt="No Image"
                  :src="'data:image/jpeg;base64,' + selectedUser.imagestring"
                />
              </v-avatar>
            </v-layout>
            <v-form
              ref="form"
              @submit.stop.prevent="checkForm"
              class="text-center"
              method="post"
            >
              <v-text-field
                v-model="selectedUser.UserName"
                validate-on-blur
                :append-icon="
                  isnewuser
                    ? isvaliduser
                      ? 'mdi mdi-check green--text'
                      : 'mdi mdi-window-close red--text'
                    : ''
                "
                v-on:keypress="isLetterOrNumber($event)"
                v-on:keyup="checkuser()"
                label="User Name"
                :readonly="isnewuser == false"
                :disabled="isnewuser == false"
                :rules="[rules.required, rules.minuser]"
                class="mx-4"
              ></v-text-field>
              <v-text-field
                v-model="selectedUser.UserFullName"
                label="Full Name"
                :rules="[rules.required]"
                class="mx-4"
              ></v-text-field>
              <v-text-field
                v-model="selectedUser.Mobile"
                label="Mobile"
                type="number"
                class="mx-4"
              ></v-text-field>
               <v-text-field
                v-model="selectedUser.targetsale"
                label="Target Sale"
                type="number"
                class="mx-4"
              ></v-text-field>
              <div v-if="isnewuser == true">
                <v-col cols="12" sm="4"
                  ><v-text-field
                    v-model="selectedUser.password"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min, rules.strength]"
                    validate-on-blur
                    :type="showPassword ? 'text' : 'password'"
                    label="Password"
                    class="mb-6"
                    @click:append="showPassword = !showPassword"
                  ></v-text-field>
                  <v-progress-linear
                    :color="score.color"
                    :value="score.value"
                  ></v-progress-linear>
                </v-col>
              </div>
              <v-row
                ><v-col>
                  <v-checkbox
                    v-model="selectedUser.enabled"
                    label="Active"
                  ></v-checkbox> </v-col
                ><v-col>
                  <v-checkbox
                    v-model="selectedUser.isAdmin"
                    label="Admin"
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox
                    v-model="selectedUser.isRep"
                    label="Rep"
                  ></v-checkbox>
                </v-col>
                <v-select
                  v-if="selectedUser.isRep"
                  v-model="selectedUser.RepCode"
                  item-text="RepName"
                  item-value="RepCode"
                  :items="reps"
                  label="Rep"
                  filled
                ></v-select>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialog = false">
              Close
            </v-btn>
            <v-btn color="green darken-1" text @click="saveUser()">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import { HTTP, setAuthToken, BASE_URL } from "../../../lib/http.common";
import zxcvbn from "zxcvbn";
export default {
  data() {
    return {
      reps:[],
      showPassword: false,
      show4: false,
      password: "Password",
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) =>
          v.length >= 8 || "Use 8 characters or more for your password",
        minuser: (v) => {
          return v.length >= 4 || "Use 4 characters or more for your username";
        },
        strength: (v) =>
          zxcvbn(v).score >= 3 ||
          "Please choose a stronger password. Try a mix of letters, numbers, and symbols.",
      },
      isuserexists: false,
      isnewuser: false,
      isvaliduser: false,
      overlay: true,
      dialog: false,
      dialogtitle: "Edit User",
      dialogerror: null,
      search: "",
      name: "USERS",
      tabitems: [{ name: "All Users", index: 0 }],
      tab: null,
      errormessage: null,
      selectedUser: { password: "" },
      users: [],
      headers: [
        {
          value: "imagestring",
          text: "Profile Image",
          sortable: true,
        },
        {
          value: "id",
          text: "id",
          sortable: true,
        },
        {
          value: "UserName",
          text: "User Name",
          sortable: true,
        },
        {
          value: "UserFullName",
          text: "User Full Name",
          sortable: true,
        },
        {
          value: "Mobile",
          text: "Mobile",
          sortable: false,
        },
        {
          value: "isAdmin",
          text: "Admin",
          sortable: true,
        },
        {
          value: "isRep",
          text: "Rep",
          sortable: true,
        },

        {
          value: "enabled",
          text: "Active",
          sortable: true,
        },
        { value: "actions", text: "Actions" },
      ],
    };
  },
  methods: {
    
    getreps() {
      HTTP.get(BASE_URL + `reps`)
        .then((response) => {
          if (response.data[0].success) {
            this.errormessage = null;
            this.reps =response.data[0].dataset;

          } else {
            if (!response.data[0].season) this.$router.push("/login");
            this.errormessage = response.data[0].message;
          }
        })
        .catch((e) => {
          this.errormessage = e;
        });
    },
    checkDel(item) {
      if (!item.enabled) {
        return "deleted";
      } else return "";
    },
    filterOnlyCapsText(value, search) {
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value
          .toString()
          .toLocaleLowerCase()
          .indexOf(search.toLocaleLowerCase()) !== -1
      );
    },
    newUser() {
      this.dialogtitle = "Add User";
      this.selectedUser = { UserName: "", password: "", enabled: true };
      this.isnewuser = true;
      this.dialog = true;
      this.isvaliduser = false;
    },
    isLetterOrNumber(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-z0-9]+$/.test(char)) return true;
      else e.preventDefault();
    },
    setemptyuser() {
      this.selectedUser.id = 0;
      this.selectedUser.UserFullName = "";
      this.selectedUser.enabled = true;
      this.selectedUser.password = "";
      this.selectedUser.permission = 0;
      this.selectedUser.targetsale=0;
      this.selectedUser.isAdmin = false;
      this.selectedUser.isRep = false;
      this.selectedUser.userimage = null;
      this.selectedUser.imagestring = null;
      if (this.selectedUser.UserName.length > 0) this.isvaliduser = true;
      else this.isvaliduser = false;
    },
    checkuser() {
      let user = this.selectedUser.UserName;

      if (user !== undefined && user.length > 0) {
        HTTP.get(BASE_URL + `check/${user}`)
          .then((response) => {
            if (response.data[0].success) {
              this.dialogerror = response.data[0].message;
              if (response.data[0].dataset.length > 0) {
                response.data[0].dataset;
                this.selectedUser = response.data[0].dataset[0];
                this.isvaliduser = false;
                this.dialogerror = "User name exists";
              } else {
                this.dialogerror = null;
                this.setemptyuser();
              }
            } else {
            if (!response.data[0].season) this.$router.push("/login");
              
              this.dialogerror = null;

            }
          })
          .catch((e) => {
            this.dialogerror = e;
          });
      } else if (user == undefined) {
        this.setemptyuser();
      } else if (user.length == 0) {
        this.setemptyuser();
      } else {
        this.setemptyuser();
      }
    },
    checkForm() {
      this.$refs.form.validate();
    },
    saveUser() {
      this.checkForm();
      this.dialogerror = null;
      if (this.selectedUser.UserName && this.selectedUser.UserFullName) {
        if (this.isnewuser && this.selectedUser.password.length < 8)
          this.dialogerror = "Please check password!";
        else {
          HTTP.post(
            BASE_URL + `users/${this.isnewuser ? "reg" : "update"}/`,
            this.selectedUser
          )
            .then((response) => {
              this.error = response.data[0].success;
              if (!response.data[0].success) {
            if (!response.data[0].season) this.$router.push("/login");

                this.dialogerror = response.data[0].message;
              } else {
                this.dialogerror = null;
                this.dialog = false;
                this.getUsers();
              }
            })
            .catch((e) => {
              this.dialogerror = e;
            });
        }
      } else {
        this.dialogerror = "Check form data!!";
      }
    },
    getUsers() {
      HTTP.get(BASE_URL + "users")
        .then((response) => {
          this.error = response.data[0].success;
          if (!response.data[0].success) {
            if (!response.data[0].season) this.$router.push("/login");

            this.errormessage = response.data[0].message;
          } else {
            this.errormessage = null;
            this.users = response.data[0].dataset;
          }
        })
        .catch((e) => {
          this.errormessage = e;
        });
      this.overlay = false;
    },
    getUserDetails(username) {
      this.isnewuser = false;
      this.dialogtitle = "Edit User";
      HTTP.get(BASE_URL + `users/` + username)
        .then((response) => {
          this.error = response.data[0].success;
          if (!response.data[0].success) {
            if (!response.data[0].season) this.$router.push("/login");

            this.errormessage = response.data[0].message;
          } else {
            this.errormessage = null;
            this.selectedUser = response.data[0].dataset[0];
          }
          this.dialog = true;
        })
        .catch((e) => {
          this.errormessage = e;
        });
    },

    formaticon(v) {
      if (v) {
        return '<i class="mdi mdi-check green--text"></i>';
      } else {
        return '<i class="mdi mdi-window-close red--text"></i>';
      }
    },
  },
  computed: {
    UserFullName: function () {
      if (this.selectedUser.UserFullName)
        return this.selectedUser.UserFullName.toUpperCase();
      return "";
    },
    score() {
      const result = zxcvbn(this.selectedUser.password);

      switch (result.score) {
        case 4:
          return {
            color: "light-blue",
            value: 100,
          };
        case 3:
          return {
            color: "light-green",
            value: 75,
          };
        case 2:
          return {
            color: "yellow",
            value: 50,
          };
        case 1:
          return {
            color: "orange",
            value: 25,
          };
        default:
          return {
            color: "red",
            value: 0,
          };
      }
    },
  },
  mounted() {
    this.getUsers();
    this.getreps();
  },
  beforeCreate() {
    setAuthToken();
    console.clear();
  },
};
</script>

<style scoped>
.v-application .mb-6 {
  margin-bottom: 0px !important;
}
</style>